export const setMediaQuery = (min, max) => (mediaQuery) => {
  if (!min) {
    // css valid for screen lower than max
    return `@media only screen and (max-width: ${mediaQuery[max] - 1}px)`
  } else if (!max) {
    // css valid for screen larger than min
    return `@media only screen and (min-width: ${mediaQuery[min]}px)`
  }
  const minWidth = mediaQuery[min] + 1
  const maxWidth = mediaQuery[max]
  // css valid for screen larger than min but lower than max
  return `@media only screen and (min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`
}

export const getDeepValue = (theme, ...keys) => keys.reduce((result, curr) => result[curr] || {}, theme) || {}

export const createDynamicStyle = (theme, ...keys) => (extra = {}) => {
  const style = getDeepValue(theme, ...keys)
  const { mediaQuery } = theme
  const {
    mobile,
    tablet,
    desktop,
    mobileOnly,
    tabletOnly,
    desktopOnly,
    ...rest // for mobile
  } = style
  // extra is used in component mostly add style by some conditional prop
  const {
    mobile: extraMobile,
    tablet: extraTablet,
    desktop: extraDesktop,
    mobileOnly: extraMobileOnly,
    tabletOnly: extraTabletOnly,
    desktopOnly: extraDesktopOnly,
    ...otherExtra
  } = extra
  return {
    ...rest,
    ...mobile,
    ...extraMobile,
    ...attachStyle(tablet, { [setMediaQuery('tablet')(mediaQuery)]: { ...tablet, ...extraTablet } }),
    ...attachStyle(desktop, { [setMediaQuery('desktop')(mediaQuery)]: { ...desktop, ...extraDesktop } }),
    ...attachStyle(
      mobileOnly || extraMobileOnly,
      { [setMediaQuery(null, 'tablet')(mediaQuery)]: { ...mobileOnly, ...extraMobileOnly } },
    ),
    ...attachStyle(
      tabletOnly || extraTabletOnly,
      { [setMediaQuery('tablet', 'desktop')(mediaQuery)]: { ...tabletOnly, ...extraTabletOnly } },
    ),
    ...attachStyle(
      desktopOnly || extraDesktopOnly,
      { [setMediaQuery('desktop')(mediaQuery)]: { ...desktopOnly, ...extraDesktopOnly } },
    ),
    ...otherExtra,
  }
}

export const attachStyle = (bool, style) => ({ ...!!bool && style })



// WEBPACK FOOTER //
// ./src/cms/helpers/styledComponents.js